import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Mensaje de error de un campo, bajo el campo.
 *
 * El estandar de diseno (harness/skills/muveran-design/SKILL.md) manda que el
 * error se vea donde esta el campo que fallo, no en un banner lejano ni en un
 * toast. Esto existe para que esa regla tenga una sola implementacion en vez de
 * una por pantalla.
 *
 * Uso: el campo lleva `aria-invalid` y `aria-describedby` apuntando al `id` de
 * este elemento, que es lo que hace que un lector de pantalla lo anuncie al
 * enfocar el campo.
 *
 *   <Input aria-invalid={!!error} aria-describedby={error ? "x-error" : undefined} />
 *   <FieldError id="x-error">{error}</FieldError>
 *
 * No renderiza nada si no hay mensaje, para poder llamarlo siempre.
 */
const FieldError = React.forwardRef<
  HTMLParagraphElement,
  React.ComponentProps<"p">
>(({ className, children, ...props }, ref) => {
  if (!children) return null
  return (
    <p
      ref={ref}
      role="alert"
      className={cn("text-sm text-destructive", className)}
      {...props}
    >
      {children}
    </p>
  )
})
FieldError.displayName = "FieldError"

export { FieldError }
